import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SocialMediaGetAllService } from '../../services';

export const fetchSocialMediaGetAll = createAsyncThunk(
    'socialMediaGetAll/fetchSocialMediaGetAll',
    async () => {
        var data = localStorage.getItem('SocialMedias')
        if (data) {
            return JSON.parse(data)
        }
        const response = await SocialMediaGetAllService()
        localStorage.setItem('SocialMedias', JSON.stringify(response.result))
        return response.result
    }
);

const socialMediaGetAllSlice = createSlice({
    name: 'socialMediaGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSocialMediaGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSocialMediaGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSocialMediaGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default socialMediaGetAllSlice.reducer;
